import {useRouter} from 'next/router';
import {useEffect} from 'react';

export default function routeChangeHook(callback: () => void) {
  const { events } = useRouter();

  useEffect(() => {
    events.on('routeChangeStart', callback);

    return () => {
      events.off('routeChangeStart', callback);
    };
  }, []);
}
